import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function QuoteDialog({ machinery, trigger }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: user?.name || "", email: user?.email || "", phone: user?.phone || "",
    company: user?.company || "", listing_type: machinery.listing_type === "venta" ? "venta" : "alquiler",
    start_date: "", end_date: "", message: "",
  });

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/quotes", { machinery_id: machinery.id, ...form });
      toast.success("¡Cotización enviada! Nuestro equipo te contactará pronto.");
      setOpen(false);
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="sm:max-w-lg" data-testid="quote-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl tracking-tight">Solicitar Cotización</DialogTitle>
          <DialogDescription className="text-sm text-muted-foreground">{machinery.name}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Nombre *</Label><Input required value={form.name} onChange={set("name")} data-testid="quote-name" /></div>
            <div><Label>Empresa</Label><Input value={form.company} onChange={set("company")} data-testid="quote-company" /></div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Correo *</Label><Input type="email" required value={form.email} onChange={set("email")} data-testid="quote-email" /></div>
            <div><Label>Teléfono</Label><Input value={form.phone} onChange={set("phone")} data-testid="quote-phone" /></div>
          </div>
          <div>
            <Label>Modalidad</Label>
            <select value={form.listing_type} onChange={set("listing_type")} data-testid="quote-listing-type"
              className="w-full h-10 px-3 bg-background border border-input text-sm">
              <option value="alquiler">Alquiler</option>
              <option value="venta">Compra</option>
            </select>
          </div>
          {form.listing_type === "alquiler" && (
            <div className="grid grid-cols-2 gap-3">
              <div><Label>Desde</Label><Input type="date" value={form.start_date} onChange={set("start_date")} data-testid="quote-start" /></div>
              <div><Label>Hasta</Label><Input type="date" value={form.end_date} onChange={set("end_date")} data-testid="quote-end" /></div>
            </div>
          )}
          <div><Label>Mensaje</Label><Textarea rows={3} value={form.message} onChange={set("message")} data-testid="quote-message" placeholder="Cuéntanos sobre tu proyecto..." /></div>
          <DialogFooter>
            <button type="submit" disabled={loading} data-testid="quote-submit"
              className="w-full h-11 bg-brand text-black font-semibold hover:bg-brand-hover transition-colors disabled:opacity-60">
              {loading ? "Enviando..." : "Enviar solicitud"}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
